import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c322b6d")

_pushScopeId("data-v-3c322b6d")
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "mt-1" }
const _hoisted_5 = { class: "text-muted" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VDPopupListbox = _resolveComponent("VDPopupListbox")!

  return (_openBlock(), _createBlock(_component_VDPopupListbox, {
    ref: "listbox",
    dataKey: ['profileId'],
    disabled: _ctx.disabled,
    onOptionAdded: _ctx.onProfileSelected,
    disabledOptions: _ctx.addedProfiles,
    filterFields: ['name'],
    isLoading: _ctx.loading,
    groupedOptions: _ctx.groupedProfiles
  }, {
    default: _withId(({ option }) => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(option.name), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("small", _hoisted_5, _toDisplayString(_ctx.getAssignableRolesCount(option)) + "/" + _toDisplayString(option.roles?.length || 0) + " tildelbare " + _toDisplayString(_ctx.getAssignableRolesCount(option) === 1 ? "rolle" : "roller"), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["disabled", "onOptionAdded", "disabledOptions", "isLoading", "groupedOptions"]))
})